import { clearSuggestions, suggestionsInputSelector } from '../../steady/discover';
import tippy from 'tippy.js';
const suggestionSelector = '.js-project_search__suggestion';
const inputSelector = '.js-backend_publication_recommendations_suggestion_input';
const descriptionInputSelector = '.js-backend_publication_recommendations_description';
const titleSelector = '.js-backend_publication_recommendations_preview_title';
const logoSelector = '.js-backend_publication_recommendations_preview_logo';
const descriptionSelector = '.js-backend_publication_recommendations_preview_description';
window.up.compiler(suggestionSelector, function (suggestion) {
    const { id, title, logo, description } = JSON.parse(suggestion.dataset.publication || '{}');
    const suggestionInput = document.querySelector(suggestionsInputSelector);
    const descriptionInput = document.querySelector(descriptionInputSelector);
    const input = document.querySelector(inputSelector);
    const previewTitle = document.querySelector(titleSelector);
    const previewLogo = document.querySelector(logoSelector);
    const previewDescription = document.querySelector(descriptionSelector);
    if (suggestionInput &&
        descriptionInput &&
        previewTitle &&
        previewLogo &&
        previewDescription &&
        input &&
        id &&
        title) {
        window.up.on(suggestion, 'click', undefined, () => {
            var _a;
            input.value = id;
            suggestionInput.value = title;
            descriptionInput.value = description;
            descriptionInput.disabled = false;
            // this event will trigger the character count update
            descriptionInput.dispatchEvent(new Event('change'));
            previewTitle.innerText = title;
            previewLogo.src = logo;
            previewDescription.innerText = description;
            clearSuggestions();
            const errorDescriptionElements = (_a = descriptionInput.closest('form')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.form_control__errors');
            errorDescriptionElements === null || errorDescriptionElements === void 0 ? void 0 : errorDescriptionElements.forEach(element => element.remove());
        });
    }
});
window.up.compiler(descriptionInputSelector, function (descriptionInput) {
    var _a;
    const description = (_a = descriptionInput.closest('form')) === null || _a === void 0 ? void 0 : _a.querySelector(descriptionSelector);
    if (description) {
        description.innerText = descriptionInput.value;
        window.up.watch(descriptionInput, {}, value => {
            description.innerText = value;
        });
    }
});
window.up.compiler('.js-backend_publication_recommendations__contacts_generated_info span', function (tableHeader) {
    const tooltip = tippy(tableHeader, { theme: 'steady-tooltip' });
    return () => tooltip.destroy();
});
